import React, { useState, useEffect } from 'react';

const InactivityWarningModal = ({ isOpen, onStayConnected }) => {
  const [timeLeft, setTimeLeft] = useState(5 * 60); // 5 minutos en segundos

  useEffect(() => {
    if (!isOpen) {
      setTimeLeft(5 * 60);
      return;
    }

    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isOpen]);

  if (!isOpen) return null;

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-2xl max-w-md w-full p-6 animate-bounce-in">
        {/* Icono de advertencia */}
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center">
            <i className="fas fa-exclamation-triangle text-yellow-600 text-3xl"></i>
          </div>
        </div>

        {/* Título */}
        <h2 className="text-2xl font-bold text-gray-900 text-center mb-2">
          Sesión por Inactividad
        </h2>

        {/* Mensaje */}
        <p className="text-gray-600 text-center mb-6">
          No hemos detectado actividad en tu cuenta por un tiempo prolongado.
          Tu sesión se cerrará automáticamente en:
        </p>

        {/* Countdown */}
        <div className="bg-gradient-to-r from-yellow-50 to-orange-50 rounded-lg p-4 mb-6">
          <div className="text-center">
            <div className="text-5xl font-bold text-orange-600 mb-2">
              {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
            </div>
            <div className="text-sm text-gray-600">minutos restantes</div>
          </div>
        </div>

        {/* Botones */}
        <div className="flex gap-3">
          <button
            onClick={onStayConnected}
            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-4 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2"
          >
            <i className="fas fa-check-circle"></i>
            Seguir Conectado
          </button>
        </div>

        {/* Nota */}
        <p className="text-xs text-gray-500 text-center mt-4">
          Cualquier actividad (mover el mouse, hacer clic, etc.) también mantendrá tu sesión activa
        </p>
      </div>

      <style dangerouslySetInnerHTML={{__html: `
        @keyframes bounce-in {
          0% {
            transform: scale(0.8);
            opacity: 0;
          }
          50% {
            transform: scale(1.05);
          }
          100% {
            transform: scale(1);
            opacity: 1;
          }
        }
        .animate-bounce-in {
          animation: bounce-in 0.4s ease-out;
        }
      `}} />
    </div>
  );
};

export default InactivityWarningModal;
